// Single source of truth for app store availability.
// Flip ANDROID_LIVE to true the day Google Play approves the app —
// every Play Store button/banner on the site turns on automatically.
export const APP_STORE_URL = "https://apps.apple.com/us/app/thetrucktrackr/id6783500007";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.thetrucktrackr.app";
export const ANDROID_LIVE = true;
